function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "heart-pulse-fill",
  clipPath: "url(#clip0_1988_3947)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M7.1492 16.5807C5.74246 15.4692 4.35839 14.0858 3.43802 12.4167H6.93615H7.21918L7.36485 12.174L7.79223 11.462L10.1136 15.3309L10.5424 16.0456L10.9711 15.3309L12.7193 12.4167H15.584H16.084V11.9167V10.0833V9.58333H15.584H11.3985H11.1155L10.9698 9.826L10.5424 10.538L8.22106 6.66909L7.79228 5.95444L7.36355 6.66912L5.61536 9.58333H2.44109C2.37125 9.15406 2.33398 8.70956 2.33398 8.25C2.33398 5.28882 4.42992 3.25 6.87565 3.25C8.40681 3.25 9.79034 4.08013 10.6471 4.93689L11.0007 5.29044L11.3542 4.93689C12.211 4.08013 13.5945 3.25 15.1257 3.25C17.604 3.25 19.6673 5.28651 19.6673 8.25C19.6673 11.2649 18.0548 13.6633 16.1004 15.506C14.3677 17.1397 12.4159 18.2914 11.1835 19.0186C11.1206 19.0557 11.0596 19.0917 11.0007 19.1265C10.9406 19.091 10.8785 19.0544 10.8144 19.0166C9.87332 18.4614 8.5156 17.6603 7.1492 16.5807Z",
  fill: "currentColor",
  stroke: "currentColor"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1988_3947"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "currentColor"
})));
function SvgBrandHealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandHealthIcon);
export default __webpack_public_path__ + "static/media/Brand Health Icon.1801c5cb1c4db392fbac6bdcf6bfaf45.svg";
export { ForwardRef as ReactComponent };